import React from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import KeyboardArrowDownSharpIcon from '@mui/icons-material/KeyboardArrowDownSharp';
import { styled } from '@mui/system';

const NormalSelect = ({
    icon: Icon = KeyboardArrowDownSharpIcon,
    className,
    value = '',
    label,
    handleChange,
    placeholder = 'Select',
    highLight,
    highLightColor,
    disabled = false,
    borderTab = false,
    list = [],
}) => {

    const CustomSelect = styled(Select)({
        border: 'none',
        '& .MuiSelect-select': {
            border: 'none',
            padding: '8px 16px', 
            backgroundColor: 'transparent',
            display: 'flex',
            alignItems: 'center',
            maxWidth: borderTab ? 'auto' : '120px',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '& .MuiInputBase-input': {
            padding: borderTab ? '10px 0' : '8px 0',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none', 
        },
        '& .MuiSelect-icon': {
            right: '8px', 
        },
        '&:focus': {
            backgroundColor: 'transparent',
        },
        // '&.Mui-disabled': {
        //     '& .MuiSelect-select': {
        //         color: highLightColor, // Apply color for disabled text
        //     },
        // },
    });

    return (
        <FormControl fullWidth disabled={disabled} className={className}>
              {label && (
                <InputLabel
                    sx={{
                        backgroundColor: "#fafafa",
                        padding: "0 5px",
                        marginLeft: "-0.5rem",
                        color: '#858485',
                        fontFamily: 'Gotham',
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "26px",
                        '&.Mui-focused': {
                            color: '#2E2E2E',
                        }
                    }}
                >{label}</InputLabel>
            )}
            <CustomSelect
                value={value}
                onChange={(e) => handleChange(e.target.value)}
                IconComponent={Icon}
                displayEmpty
                renderValue={(selected) => {
                    if (selected === '') {
                        return <span style={{ color: highLight ? highLightColor : '#000', paddingLeft: borderTab ? '1rem' : '0', fontSize: '14px' }}>{placeholder}</span>;
                    }
                    return <span style={{ color: highLight ? highLightColor : '#000', paddingLeft: borderTab ? '1rem' : '0' }}>{selected}</span>;
                }}
                MenuProps={{
                    PaperProps: {
                        style: {
                            border: 'none',
                            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.2)',
                        },
                    },
                }}
            >
                {list.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                        {item.label}
                    </MenuItem>
                ))}
            </CustomSelect>
        </FormControl>
    );
};

export default NormalSelect;
